import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { WlPage } from '@/components/layouts/AppShell';

interface ComingSoonPageProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  expectedIn?: string;
}

export const ComingSoonPage: React.FC<ComingSoonPageProps> = ({
  title,
  description = 'This feature is being built and will be available soon.',
  icon,
  expectedIn = 'Coming soon',
}) => {
  const navigate = useNavigate();
  return (
    <WlPage title={title}>
      <div className="wl-empty">
        {icon && (
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 14,
              background: 'var(--bg-2)',
              color: 'var(--teal)',
              display: 'grid',
              placeItems: 'center',
              margin: '0 auto 16px',
            }}
          >
            {icon}
          </div>
        )}
        <h3 style={{ marginBottom: 8, fontWeight: 600 }}>{title}</h3>
        <p
          style={{
            fontSize: 13.5,
            color: 'var(--ink-4)',
            maxWidth: 380,
            margin: '0 auto 16px',
            lineHeight: 1.6,
          }}
        >
          {description}
        </p>
        <span
          style={{
            display: 'inline-block',
            padding: '3px 14px',
            borderRadius: 99,
            background: 'var(--bg-2)',
            border: '1px solid var(--line)',
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.05em',
            textTransform: 'uppercase' as const,
            color: 'var(--ink-4)',
            marginBottom: 24,
          }}
        >
          {expectedIn}
        </span>
        <div>
          <button
            className="wl-btn wl-btn-secondary"
            onClick={() => navigate(-1)}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
          >
            <ArrowLeft size={14} /> Go back
          </button>
        </div>
      </div>
    </WlPage>
  );
};
